export default __webpack_public_path__ + "static/media/eva.928aea8f.png";